module.exports = __webpack_public_path__ + "img/horizontal_6_3_3009.f3e4d07a.png";